import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {SurveyFilterUIModel, SurveyQuestionFilterRawModel, AnswerTypes, FilterUIModel} from '../../../../models/survey/survey.model';
import {Subject} from 'rxjs/Subject';
import {HideQuestionModel} from '../../../../models/hide-question/hide-question.model';
import { FilterOption } from '../../../../shared/constants/filter.constants';
import { SurveyService } from '../../surveys.service';
import * as _ from 'lodash';
import { IncludeSurveyModel, SurveyCutModelCore } from '../../../../models/summary/summary.model';
import { SegmentModel } from '../../../../models/segment/SegmentModel';

@Component({
  selector: 'app-question-filter',
  templateUrl: './question-filter.component.html',
  styleUrls: ['./question-filter.component.less']
})
export class QuestionFilterComponent implements OnInit {

  @Input() listSurveyQuestionFilterRaw: SurveyQuestionFilterRawModel[];
  listSurveyQuestionFilterForChoice: SurveyQuestionFilterRawModel[];

  @Input() listOriginalSurveyFilterUI: SurveyFilterUIModel[] = [];
  listSurveyFilterUI: SurveyFilterUIModel[] = [];
  listSurveyFilter: SurveyFilterUIModel[] = [];

  @Input() originalFilterOption = FilterOption.AND;
  filterOption = '';

  @Input() includeSurvey: IncludeSurveyModel;
  @Input() okLabel: string = 'Ok';
  @Input() showSaveSegment: boolean = true;
  @Input() segment: SegmentModel;

  @Output() onQuestionFilterFinished: EventEmitter<any> = new EventEmitter<any>();
  @Output() onQuestionFilterCancelled: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() onSaveSegment: EventEmitter<any> = new EventEmitter<any>();

  eventResetSubject = new Subject<number>();
  eventValidateSubject = new Subject<number[]>();
  minYear = 1900;
  hideQuestionValues: HideQuestionModel[] = [];

  @Input()
  set hideQuestions(val) {
    this.hideQuestionValues = val;
    this.calculateListSurveyQuestionFilterForChoice();
  }

  get hideQuestions() {
    return this.hideQuestionValues;
  }

  @Input() surveyId: number;

  listSurveyCut: SurveyCutModelCore[] = [];
  savedSegmentId = 0;
  savedSegmentName = '';
  segmentName = '';
  saveSegmentLabel = 'Save Segment';

  hasSaved = false;
  errorMessage = '';
  isValidFilters = false;
  isValidName = false;

  constructor(private surveyService: SurveyService) {
  }

  listOperator: string[] = [
    '>=', '<=', '<>', '=', 'Between'
  ];

  listOperatorForDate: string[] = [
    '>=', '<=', '='
  ];

  listOperatorForMultiChoice: string[] = [
    '=', '<>'
  ];

  listOperatorForText: string[] = [
    'Response given', 'Contains', 'Does Not contain'
  ];

  listFilters: string[] = [
    FilterOption.AND, FilterOption.OR
  ];

  ngOnInit() {
    if (this.segment) {
      const name = this.segment.name ? this.segment.name : '';
      this.savedSegmentName = name;
      this.segmentName = name;
      this.savedSegmentId = this.segment.id ? this.segment.id : 0;
      this.isValidName = this.segmentName !== '';
    }
    
    this.getSegments();

    this.listSurveyFilterUI = this.cloneListSurveyFilter(this.listOriginalSurveyFilterUI);
    this.listSurveyFilter = this.cloneListSurveyFilter(this.listOriginalSurveyFilterUI);

    this.filterOption = this.originalFilterOption;
    this.calculateListSurveyQuestionFilterForChoice();

    this.checkValidFilters();
  }

  cloneListSurveyFilter(listOriginalSurveyFilter: SurveyFilterUIModel[]) {
    let listSurveyFilter: SurveyFilterUIModel[] = [];
    if (!listOriginalSurveyFilter.length) {
      listSurveyFilter.push(new SurveyFilterUIModel());
    } else {
      listOriginalSurveyFilter.forEach(s => {
        listSurveyFilter.push(Object.assign({}, s));
      });
    }
    return listSurveyFilter;
  }

  resetSelectAnswer(questionId: number) {
    this.eventResetSubject.next(questionId);
    this.onChangeFilters();
  }

  onSelectQuestion(question: SurveyQuestionFilterRawModel, surveyFilterUI: SurveyFilterUIModel, index: number) {
    if (surveyFilterUI.question) {
      this.resetSelectAnswer(index);
    }
    surveyFilterUI.question = JSON.parse(JSON.stringify(question));
    surveyFilterUI.listAnswerId = [];
    surveyFilterUI.operator = this.isMultipleOrSingleChoiceQuestion(surveyFilterUI.question) ? '=' : '';
    surveyFilterUI.input = '';
    this.calculateListSurveyQuestionFilterForChoice();
    this.onChangeFilters();
  }

  onInputAnswer(input: string, surveyFilterUI: SurveyFilterUIModel) {
    surveyFilterUI.input = input;
    this.onChangeFilters();
  }

  onSelectAnswer(listAnswerId: number[], surveyFilterUI: SurveyFilterUIModel) {
    surveyFilterUI.listAnswerId = listAnswerId;
    this.onChangeFilters();
  }

  onSelectText(input: string, surveyFilterUI: SurveyFilterUIModel) {
    surveyFilterUI.input = input;
    this.onChangeFilters();
  }

  onSelectYesNo(event: any, surveyFilterUI: SurveyFilterUIModel) {
    surveyFilterUI.listAnswerId = [event.id];
    this.onChangeFilters();
  }

  getLabelYesNo(surveyFilterUI: SurveyFilterUIModel) {
    let label: string;
    if (surveyFilterUI && surveyFilterUI.listAnswerId && surveyFilterUI.listAnswerId.length === 1) {
      const answer = surveyFilterUI.question.listSurveyAnswerFilter.find(listAnswer => listAnswer.id === surveyFilterUI.listAnswerId[0]);
      if (answer) {
        label = answer.answer;
      }
    }
    return label;
  }

  getLabelText(surveyFilterUI: SurveyFilterUIModel) {
    let label: string;
    if (surveyFilterUI.question.answerType === 'Text' && surveyFilterUI.input) {
      label = surveyFilterUI.input;
    }
    return label;
  }

  onSelectOperator(operator: string, surveyFilterUI: SurveyFilterUIModel) {
    surveyFilterUI.operator = operator;
    if (operator === 'Between') {
      surveyFilterUI.input = 'From -99999 to 99999';
    }
    this.onChangeFilters();
  }

  onSelectTextOperator(operator: string, surveyFilterUI: SurveyFilterUIModel) {
    surveyFilterUI.operator = operator;
    if (operator === 'Response given') {
      surveyFilterUI.input = 'True';
    } else {
      surveyFilterUI.input = '';
    }
    this.onChangeFilters();
  }

  addNewQuestion() {
    this.listSurveyFilterUI.push(new SurveyFilterUIModel());
    this.onChangeFilters();
  }

  removeQuestion(index: number) {
    this.listSurveyFilterUI.splice(index, 1);

    if (!this.listSurveyFilterUI.length) {
      this.listSurveyFilterUI.push(new SurveyFilterUIModel());
    }

    this.calculateListSurveyQuestionFilterForChoice();
    this.onChangeFilters();
  }

  resetQuestion() {
    this.filterOption = FilterOption.AND;
    this.listSurveyFilterUI = [];
    this.listSurveyFilterUI.push(new SurveyFilterUIModel());
    this.calculateListSurveyQuestionFilterForChoice();
    this.onChangeFilters();
  }

  onOkClicked() {
    if (this.validateForm()) {
      const filter = new FilterUIModel(this.filterOption, this.listSurveyFilterUI, this.segmentName);
      this.onQuestionFilterFinished.emit(filter);
    }
  }

  validateForm(): boolean {
    const listSelectedSurveyFilterUI = this.listSurveyFilterUI.filter(s => s.question);
    const listQuestionId = listSelectedSurveyFilterUI.map(s => s.question.id);
    this.eventValidateSubject.next(listQuestionId);

    let isValid = true;

    listSelectedSurveyFilterUI.forEach(s => {
      if (this.isChoiceQuestion(s.question)) {
        if (!s.listAnswerId.length) {
          isValid = false;
        }
      } else {
        if (s.question.answerType !== 'Text' && !(s.input !== '' && s.input !== null && s.operator)) {
          isValid = false;
        } else if (s.question.answerType === 'Text' && !(s.input !== '' && s.input !== null)) {
          isValid = false;
        }else {
          if (s.question.answerType === 'Date') {
            const yearInput = new Date(s.input).getFullYear();
            if (yearInput < this.minYear) {
              isValid = false;
            }
          }
        }
      }
    });

    return isValid;
  }

  onCancelClicked() {
    this.onQuestionFilterCancelled.emit(true);
  }

  isYesNoQuestion(question: SurveyQuestionFilterRawModel) {
    return 'YesNo' === question.answerType;
  }

  isPictureChoiceQuestion(question: SurveyQuestionFilterRawModel) {
    return 'PictureChoice' === question.answerType;
  }

  isDateQuestion(question: SurveyQuestionFilterRawModel) {
    return 'Date' === question.answerType;
  }

  isMultipleOrSingleChoiceQuestion(question: SurveyQuestionFilterRawModel) {
    return 'MultipleChoice' === question.answerType || 'SingleChoice' === question.answerType;
  }

  isChoiceQuestion(question: SurveyQuestionFilterRawModel) {
    const listChoiceQuestionType: string[] = [
      'SingleChoice', 'MultipleChoice', 'Dropwdown', 'PictureChoice', 'YesNo'
    ];

    return listChoiceQuestionType.includes(question.answerType);
  }

  isInputQuestion(question: SurveyQuestionFilterRawModel) {
    const listInputQuestionType: string[] = [
      'Number', 'Rating', 'OpinionScale', 'Date'
    ];

    return listInputQuestionType.includes(question.answerType);
  }

  isShowInputText(question: SurveyQuestionFilterRawModel) {
    return this.isInputQuestion(question) && !this.isDateQuestion(question) && !this.isMultipleOrSingleChoiceQuestion(question);
  }

  isTextQuestion(question: SurveyQuestionFilterRawModel) {
    return question.answerType === 'Text';
  }

  calculateListSurveyQuestionFilterForChoice() {
    const hideQuestionIds = this.hideQuestions.map(x => x.questionId);
    this.listSurveyQuestionFilterForChoice = this.listSurveyQuestionFilterRaw
      .filter(s => !hideQuestionIds.includes(s.id));
  }

  getSegments() {
    if(this.surveyId) {
      this.surveyService.getCuts(this.surveyId).subscribe(res => {
        this.listSurveyCut = res.listCut;
      });
    }
  }

  showListOperatorByQuestionType(question: SurveyQuestionFilterRawModel) {
    if (this.isDateQuestion(question)) {
      return this.listOperatorForDate;
    } else if (this.isMultipleOrSingleChoiceQuestion(question)) {
      return this.listOperatorForMultiChoice;
    } else if (this.isTextQuestion(question)) {
      return this.listOperatorForText;
    } else {
      return this.listOperator;
    }
  }

  onSelectedFilter(event: any) {
    this.filterOption = event.value;
  }

  isEnableSegment(): boolean {
    const listSelectedSurveyFilterUI = this.listSurveyFilterUI.filter(s => s.question);
    const listQuestionId = listSelectedSurveyFilterUI.map(s => s.question.id);
    this.eventValidateSubject.next(listQuestionId);

    let isValid = true;

    listSelectedSurveyFilterUI.forEach(s => {
      if (this.isChoiceQuestion(s.question)) {
        if (!s.listAnswerId.length) {
          isValid = false;
        }
      } else {
        if (s.question.answerType !== 'Text' && !s.operator) {
          isValid = false;
        }
      }
    });

    return isValid;
  }
  
  onChangeFilters() {
    if (JSON.stringify(this.listSurveyFilterUI) !== JSON.stringify(this.listSurveyFilter)) {
      this.isValidFilters = false;
      this.hasSaved = false;
      this.saveSegmentLabel = 'Save Segment';
      this.checkValidFilters();
    }
  }

  checkValidFilters() {
    if (this.surveyId && this.listSurveyFilterUI && this.listSurveyFilterUI.length > 0) {
      const numQuestions = _.filter(this.listSurveyFilterUI, function(o) { if (o.question !== null) return o }).length;
      this.isValidFilters = numQuestions > 0;
    }
  }

  onKeyupSegmentName(e: any) {
    this.hasSaved = false;
    this.errorMessage = '';
    this.saveSegmentLabel = 'Save Segment';
    const name = e.target.value.trim();
    this.isValidName = name !== '';
    if (name !== '' && name !== this.savedSegmentName) {
      const numCuts = _.filter(this.listSurveyCut, function(o) { if (o.title === name) return o }).length;
      this.isValidName = numCuts === 0;
      if (!this.isValidName) {
        this.errorMessage = 'Name already exists';
      }
    }
    this.checkValidFilters();
  }

  changeOnBlur(): void {
    this.segmentName = this.segmentName.trim();
  }

  onSaveSegmentClicked() {
    if (this.validateForm()) {
      if (this.savedSegmentId !== 0 && this.segmentName === this.savedSegmentName) {
        this.surveyService.updateCut(this.savedSegmentId, {
          listQuestionFilter: this.listSurveyFilterUI,
          isOrOperator: this.filterOption,
          listVersion: this.includeSurvey.listSurveyVersion.map(item => item.hash)
        }).subscribe(cut => {
          this.hasSaved = true;
          this.saveSegmentLabel = 'Saved';
          this.savedSegmentId = cut.id;
          this.savedSegmentName = this.segmentName;
          this.listSurveyFilter = this.cloneListSurveyFilter(this.listSurveyFilterUI);
          this.getSegments();
          this.onSaveSegment.emit();
        }, _ => {
        });
      } else {
        this.surveyService.saveCut({
          surveyId: this.surveyId,
          title: this.segmentName,
          listQuestionFilter: this.listSurveyFilterUI,
          isOrOperator: this.filterOption,
          listVersion: this.includeSurvey.listSurveyVersion.map(item => item.hash)
        }).subscribe(cutId => {
          this.hasSaved = true;
          this.saveSegmentLabel = 'Saved';
          this.savedSegmentId = cutId;
          this.savedSegmentName = this.segmentName;
          this.listSurveyFilter = this.cloneListSurveyFilter(this.listSurveyFilterUI);
          this.getSegments();
          this.onSaveSegment.emit();
        }, _ => {
        });
      }
    }
  }
}




// WEBPACK FOOTER //
// ./src/app/routes/surveys/master-summary/question-filter/question-filter.component.ts